import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  labelWidth: '150px',
  formItems: [
    {
      field: 'parentDeptId',
      type: 'select',
      label: '组',
      clearable: true,
      placeholder: '请选择组',
      filterable: true,
      options: []
    },
    {
      field: 'deptName',
      type: 'select',
      label: '岗位',
      clearable: true,
      placeholder: '请选择岗位',
      filterable: true,
      options: [
        { title: '全部', value: '' },
        { title: '518', value: '518' },
        { title: '投教', value: '投教' }
      ]
    },
    {
      field: 'isVoice',
      type: 'select',
      label: '30分钟且十通1分钟',
      clearable: true,
      placeholder: '请选择',
      filterable: true,
      options: [
        { title: '不限', value: 0 },
        { title: '是', value: 1 },
        { title: '否', value: 2 }
      ]
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '筛选日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
